<div class="topHead">
    <h2>Manage Assessments</h2>
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">
    <div class="pageTitleBox">
        <h2>Manage Assessments</h2>
    </div>
    <div class="adminTabWrap">
        <div class="filterWrap courseFiltr">
            <div class="searchWrap mr-5">
                <input type="text" placeholder="Search by Assessment Name"  (keyup)="search($event)" />
            </div>
            <a href="javascript:void(0);" [routerLink]="['/create-assessment']" class="btn btn-primary btn-sm createBtn">+
                 Create New Assessment</a>
        </div>
        <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="onSelectChange($event)">
            <mat-tab label="Active" (click)="manageAssesmentList('',1)">
                <div class="tableWrap">

                    <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                        <thead>
                            <tr>
                                <th>
                                    <div mat-sort-header="capsule_name"><b></b> Content Capsule Name</div>
                                </th>
                                <th>Created On</th>
                                <th>Created By</th>
                                <th>No. of questions</th>
                                <th>Assigned To (Users)</th>
                                <!-- <th>Assigned<br/>To (Users)</th> -->
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let values of manageAssesmentListData; let i = index">
                                <td>
                                    <div class="userTdWrap">
                                        <a href="javascript:void(0);" class="btn-link" [ngbTooltip]="values?.assessment_name | wordCountTooltip: 3"
                                        [routerLink]="['/view-assessment']"
                                            [queryParams]="{id:values.assessment_id}">{{values?.assessment_name}}</a>
                                        <!-- <li> <a href="javascript:void(0);"
                                            *ngIf="values.assessment_id !=''"
                                            class="btn-link"
                                            [routerLink]="['/view-assessment']"
                                            [queryParams]="{id:values.assessment_id}"><span>View</span></a></li> -->
                                        <b>Created on {{values?.created_dttm}}</b>
                                    </div>
                                </td>
                                <!-- <td>
                                    <div class="expireDate">
                                        {{values?.end_date}}
                                    </div>
                                    <a href="javascript:void(0);" (click)="open0(content02,values.assessment_id)" class="btn-link">EXTEND</a>
                                    <span *ngIf="cousreEndDate(values.end_date) > 0.9">Course Ended</span>
                                </td> -->
                                <td>{{values?.created_dttm}}</td>
                                <td>{{values?.created_by}}</td>

                                <td>{{values?.no_question}}</td>
                                <td>{{values?.assigned_users}}</td>
                                <td>
                                    <ul class="userActionBtn">
                                        <!-- <li *ngIf="values.assigned_users_count == 0 && cousreEndDate(values.end_date) <= 0"><a href="javascript:void(0);" class="btn-link">EDIT</a></li> -->
                                        <li *ngIf="values.assigned_users==0"><a href="javascript:void(0);" class="btn-link"  [routerLink]="['/create-assessment']"
                                            [queryParams]="{assId:values.assessment_id}">EDIT</a></li>

                                        <li> <a href="javascript:void(0);"
                                            *ngIf="values.assessment_id !=''"
                                            class="btn-link"
                                            [routerLink]="['/view-assessment']"
                                            [queryParams]="{id:values.assessment_id}"><span>View</span></a></li>
                                        <li> <a href="javascript:void(0);"
                                            *ngIf="values.assessment_id !=''"
                                            class="btn-link"
                                            [routerLink]="['/assign-users']"
                                            [queryParams]="{id:values.assessment_id}"><span>Assign User</span></a></li>

                                            <li  class="w-auto" ><a href="javascript:void(0);" class="btn-link" (click)="open(duplicate,values,'Active')">DUPLICATE</a></li>

                                        <li><a href="javascript:void(0);" class="btn-link second-link"
                                                (click)="open(deactivate,values,'Active')" >DEACTIVATE</a></li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </mat-tab>
            <mat-tab label="Deactivated" (click)="manageAssesmentList('',0)">
                <div class="tableWrap">
                    <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                        <thead>
                            <tr>
                                <th>
                                    <div mat-sort-header="capsule_name"><b></b> Content Capsule Name</div>
                                </th>

                                <th>Created By</th>
                                <th>No. of questions</th>
                                <th>Assigned To (Users)</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let values of manageAssesmentListData; let i = index">
                                <td>
                                    <div class="userTdWrap">
                                        <!-- <a href="javascript:void(0);" class="btn-link"
                                            [routerLink]="['/courses_view_courses']"
                                            [queryParams]="{courseId:values.assessment_id,tab:1}">{{values?.capsule_name}}</a> -->
                                        <a href="javascript:void(0);" class="btn-link" [routerLink]="['/view-assessment']"
                                            [queryParams]="{id:values.assessment_id}"
                                           >{{values?.assessment_name}}2</a>
                                        <b>Created on {{values?.created_dttm}}</b>
                                    </div>
                                </td>
                                <td>{{values?.created_by}}</td>
                                <td>{{values?.no_question}} </td>
                                <td>{{values?.assigned_users}}</td>
                                <td>
                                    <ul class="userActionBtn">
                                        <li> <a href="javascript:void(0);"
                                            *ngIf="values.assessment_id !=''"
                                            class="btn-link"
                                            [routerLink]="['/view-assessment']"
                                            [queryParams]="{id:values.assessment_id}"><span>View</span></a></li>
                                            <li  class="w-auto" ><a href="javascript:void(0);" class="btn-link" (click)="open(duplicate,values,'Deactivated')">DUPLICATE</a></li>

                                        <li><a href="javascript:void();"
                                                (click)="open(active,values,'Deactivated')"
                                                class="btn-link-green">ACTIVATE</a></li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </mat-tab>
            <mat-tab label="DRAFT" (click)="manageAssesmentList('',0)">
                <div class="tableWrap">
                    <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                        <thead>
                            <tr>
                                <th>
                                    <div mat-sort-header="capsule_name"><b></b> Assessment Name</div>
                                </th>
                                <th>Created By</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="selectTr" *ngFor="let values of manageAssesmentListData; let i = index">
                                <td>
                                    <div class="userTdWrap">
                                        <a href="javascript:void(0);" class="btn-link" [routerLink]="['/view-assessment']" [queryParams]="{id:values.assessment_id,tab:2}">{{values?.assessment_name}}</a>
                                        <b>Created on {{values?.created_dttm}}</b>
                                    </div>
                                </td>
                                <td>
                                    {{values?.created_by}}
                                </td>
                                <td>
                                    <ul class="userActionBtn">
                                        <li  class="w-auto" ><a href="javascript:void(0);" class="btn-link"
                                                [routerLink]="['/view-assessment']" [queryParams]="{id:values.assessment_id,tab:2}">PREVIEW</a></li>
                                        <li  class="w-auto" ><a href="javascript:void(0);" class="btn-link" (click)="open(duplicate,values,'Draft')">DUPLICATE</a></li>
                                        <li><a href="javascript:void(0);" class="btn-link"
                                                (click)="open(publish,values,'DRAFT')">PUBLISH</a></li>
                                        <li><a href="javascript:void(0);" class="btn-link second-link"
                                                (click)="open(delete,values,'DRAFT')">DELETE</a></li>

                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </mat-tab>

        </mat-tab-group>

    </div>

</div>

<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate assessment</h6>
                <p class="size18">Are you sure you want to deactivate this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(0)">Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate assessment</h6>
                <p class="size18">Are you sure you want to duplicate this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="duplicateAssessment(tabName)">Yes, Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #publish let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Publish assessment</h6>
                <p class="size18">Are you sure you want to publish this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="assessmentPublised()">Yes,
                    Publish</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #active let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate assessment</h6>
                <p class="size18">Are you sure you want to activate this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsActiveVal(1)">Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #delete let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Delete Assessment</h6>
                <p class="size18">Are you sure you want to delete this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="deleteAssessment()">Yes,
                    Delete</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #content02 let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <form [formGroup]="extendForm">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
              </button>
              <div *ngIf="activeCourse">
                <h6>Extend </h6>
                <p class="size18">Select a date to extend the end date of the course.</p>
                <div class="commanInput commanDate">
                    <mat-form-field class="example-full-width" (click)="picker.open()">
                        <mat-label>Choose a date</mat-label>
                        <input matInput [min]="minDate"  formControlName="endDate" [matDatepicker]="picker" placeholder="Select Date" [readonly]=true>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                </div>
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="successExtendDate()"  class="btn btn-primary btn-sm">Extend Course</a>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">

            </div>
            <div *ngIf="succesCourse">
               <figure><img src="assets/images/admin/circle_check.png" /></figure>
                <p class="size18">You have successfully Extend.<br/></p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <!-- <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.dismiss('Cross click')">Close</a> -->
                <a href="javascript:void(0);" (click)="successDate();modal.dismiss('Cross click')"  class="btn btn-primary btn-sm">Close</a>
            </div>
        </form>
        </div>
    </div>
  </ng-template>
